export const dateTimeFormat = 'YYYY-MM-DDTHH:mm'
export const dateFormat = 'YYYY-MM-DD'

export const millisecondsToMinutes = (milliseconds) => milliseconds / 60000
